import React, { useState, useEffect } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button,  ModalBody, Modal } from "reactstrap";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid } from '@mui/x-data-grid';
import Chip from '@mui/material/Chip';
import History from "./History";
import { user_requisition,user_filter,filter_requistion,requisition_summary } from "../../api/requisition";
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import {  useDispatch } from "react-redux";
import { StorePageHeaderName } from '../../store/pageHeader/action';
import Dashboard from "./dashboard";

const CustomDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    display: 'flex',
    justifyContent: 'center',
  },
}));
const ExecutiveDashboard = () => {
  const [open, setOpen] = useState(false)
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // New state variable for loading indicator
  const [productList, setProductList] = useState([]); // State variable for product list
  const [reqNoList, setReqNoList] = useState([]); // State variable for product list
  const [selectedProductName, setSelectedProductName] = useState(null);
  const [selectedReqNo, setSelectedReqNo] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [totalRequisition, setTotalRequisition] = useState(null);
  const [totalApprovedRequisition, setTotalApprovedRequisition] = useState(null);
  const [totalNotApprovedRequisition, setTotalNotApprovedRequisition] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const dispatch = useDispatch();


  document.title ="Dashboard | Procurement Dashboard";

  
  const handleProductNameClick = (isOpen, id) => {
    setOpen(isOpen)
    setSelectedRowId(id); // Set the selected row id

  };
  const [showList, setShowList] = useState(false);

  const toggleList = () => {
    setShowList(!showList);
  };

  const columns = [
    { field: 'Sl_No', headerName: 'Sl.No',// width: 90
    headerAlign: 'center',
    cellClassName: 'center-aligndata',
    flex: 1,
    sortable: false,
    resizable: false,
     },
    {
      field: 'Requisition_No',
      headerName: 'Requisition No',
      headerClassName: 'break-header',
     width: 120,
     sortable: false,
      resizable: false,
      // flex: 1
    },
    {
      field: 'Requisition_Date',
      headerName: 'Requisition Date',
      headerClassName: 'break-header ',
    //  width: 160,
    sortable: false,
      resizable: false,
      flex: 1
    },
    {
      field: 'Product_Name',
      headerName: 'Product Name',
      headerClassName: 'break-header',
      cellClassName: 'product_name_wrap',
      width: 160,
      // flex: 1,
      sortable: false,
      resizable: false,
      renderCell: (params) => {
        const productName = params.value;
      },
    },
    {
      field: 'Total_Qty',
      headerName: 'Total Quantity',
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      // width: 130,
      headerAlign: 'center',
      headerClassName: 'break-header',
      cellClassName: 'center-aligndata',
      flex: 1
    },
    {
      field: 'approved',
      headerName: 'Approved',
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      //width: 120,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1
    },
    {
      field: 'remaining',
      headerName: 'Remaining',
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      //width: 120,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1
    },
    {
        field: 'Value',
        headerName: 'Value',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        resizable: false,
       // width: 120,
       headerAlign: 'center',
        cellClassName: 'center-aligndata',
        flex: 1
      },
      {
        field: 'Allocation_QTY',
        headerName: 'Allocation (QTY)',
        headerClassName: 'break-header',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        resizable: false,
        //width: 130,
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
        flex: 1
      },
      
      {
        field: 'Arival_Date',
        headerName: 'Arival Date',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        resizable: false,
        //width: 130,
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
        flex: 1
      },
      {
        field: 'Status',
        headerName: 'Status',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        resizable: false,
        maxWidth: 180,
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
        flex: 1,
        renderCell: (params) => {
            let status = params.value;
            let chipColor = 'default';
            if (status === 'Pending') {
              chipColor = 'error'; // Red color for waiting for response
              status = 'Waiting for response'; // Change status text

            } else if (status === 'Approved') {
              chipColor = 'success'; // Green color for approved
            }     
            return <Chip className="status_badge" label={status} variant="outlined" color={chipColor} />;
          },
      },
  ];
  
 

  useEffect(()=>{
    dispatch(StorePageHeaderName('Dashboard'))

},[])
  useEffect(()=>{
    if(showList){
      const fetchProductList = async(search_type)=>{
        try{
  
          const response = await user_filter({search_type});
          if (response.statusCode === 200) {
            if(search_type === 'productName'){
            if (response.data.product.length > 0) {
              setProductList(response.data.product); // Update productList state with fetched data
            }
           
          }
          else if (search_type === 'reqNo') {
            if (response.data.reqNo.length > 0) {
              setReqNoList(response.data.reqNo); // Update productList state with fetched data
            }
          }
          }
        }
        catch (error) {
          console.error('Error fetching product list:', error);
          toast.error('Something went wrong')
  
        }
      }
      fetchProductList('productName');
      fetchProductList('reqNo');

    }
    
    else {
      handleReset()
    }
  },[showList])
  const handleProductNameChange = (event, value) => {
    setSelectedProductName(value);
  };

  const handleReqNoChange = (event, value) => {
    setSelectedReqNo(value);

  };

  const handleSearch = async() => {
    try {
      setIsLoading(true); // Set loading state
      if ((selectedDate && !selectedEndDate) || (!selectedDate && selectedEndDate)) {
        toast.error('Please select valid daterange.'); 
        return;
      }
  
      let count = 0; 

      let searchCriteria = {};
  
      if (selectedProductName) {
        searchCriteria.item_no = selectedProductName.value;
      }
  
      if (selectedReqNo) {
        searchCriteria.requisition_no = selectedReqNo.value;
      }
      if (selectedDate) {     
        searchCriteria.requisition_date =  dayjs(selectedDate).format('YYYY-MM-DD')
        searchCriteria.requisition_end_date =  dayjs(selectedEndDate).format('YYYY-MM-DD')

      }
  
      const response = await filter_requistion(searchCriteria);
  
      if (response.statusCode === 200) {
        // Process the fetched data
        if(response.data.getRequisition.length >0){
          const requisitionItems = response.data.getRequisition.flatMap((requisition) =>
            requisition.procurementRequisitionItem.map((item) => ({
              id: item.id,
              Sl_No: ++count,
              Requisition_No: requisition.requisition_number,
              Requisition_Date: requisition.requisition_date,
              Product_Name: item.item_name,
              Total_Qty: item.total_qty,
              approved: item.approved_qty,
              remaining: item.total_qty - item.approved_qty,
              Value: item.value,
              Allocation_QTY: item.allocation_qty,
              // Actual_Date: '--',
              // Modified_Date: '--',
              Arival_Date: '--',
              Status: item.status,
            }))
          );
          setRows(requisitionItems); // Update rows state with fetched data
        }
        else{
          setRows([])
        }

      }
    } catch (error) {
      console.error('Error searching requisition:', error);
      toast.error('Something went wrong while searching');
    } finally {
      setIsLoading(false); // Reset loading state after operation completes
    }

  }
  const handleDateChange = (date) => {
    setSelectedDate(date)
  };
  const handleEndDateChange = (date) => {
    setSelectedEndDate(date)
  };
  const handleReset = () => {
    setSelectedProductName(null);
    setSelectedReqNo(null);
    setSelectedDate(null);
    setSelectedEndDate(null);

    fetchRequisitionHistory()
  };
  

  const fetchRequisitionHistory = async (payload = {}) => {
    try {
      setIsLoading(true)
      let count = 0; // Initialize the count variable outside the map function
      const response = await user_requisition(payload);

    
      if(response.statusCode ===200 && response.data.getRequisition.length >0){
        let results = response.data.getRequisition.flatMap(requisition => requisition.procurementRequisitionItem.map(item => ({
            id: item.id,
            Sl_No: ++count,
            Requisition_No: requisition.requisition_number,
            Requisition_Date:requisition.requisition_date,
            Product_Name: item.item_name,
            Total_Qty: item.total_qty,
            approved: item.approved_qty,
            remaining: item.total_qty - item.approved_qty,
            Value: item.value,
            Allocation_QTY: item.allocation_qty,
            // Actual_Date: '--',
            // Modified_Date:'--',
            Arival_Date: '--',
            Status: item.status
          })));

          setRows(results);
          setTotalRequisition(results.length)
          setTotalApprovedRequisition(results.filter(el => el.Status == 'COMPLETE_APPROVED' || el.Status == 'PARTIALLY_APPROVED' || el.Status == 'EXCESS_APPROVED' || el.Status == 'APPROVED').length)
          setTotalNotApprovedRequisition(results.filter(el => el.Status == 'APPROVAL_PENDING' || el.Status == 'SAVED' || el.Status == 'REJECTED').length)
      }
      

    } catch (error) {
      console.error('Error fetching requisition history:', error);
      toast.error('Something went wrong')
      // Handle error
    }
    finally {
      setIsLoading(false); // Reset loading state after operation completes
    }
  };

  useEffect(() => {
    fetchRequisitionHistory();
  }, []);

  return (
    <React.Fragment>
     {
      open &&(
        <History handleProductNameClick={handleProductNameClick}   selectedRowId={selectedRowId} // Pass selectedRowId
        />
      )
     }
      <div className="page-content">
        <Container fluid>
                <div className="d-flex align-items-center flex-wrap gap-3">
                        <Card className="mb-3 number_requisition">
                            <CardBody>
                                <CardTitle tag="h5">
                                    <div style={{ display: 'flex', alignItems: 'center',color: 'white' }}>
                                    <LibraryAddIcon />
                                    <span style={{ marginLeft: '8px', fontSize:'22px', color:'white', fontWeight:'600' }}>{totalRequisition}</span>
                                    </div>
                                </CardTitle>
                                <CardText>
                                    <div style={{color: 'white'}}><b>Total Number of Requisitions</b></div>
                                </CardText>
                            </CardBody>
                        </Card>
                        <Card className="mb-3 approved_requisition_card">
                            <CardBody>
                                <CardTitle tag="h5">
                                    <div style={{ display: 'flex', alignItems: 'center' , color:'white'}}>
                                        <b> <DoneAllIcon /></b>
                                    <span style={{ marginLeft: '8px', color:'white',fontSize:'22px', fontWeight:'600' }}>{totalApprovedRequisition}</span>
                                    </div>
                                </CardTitle>
                                <CardText>
                                    <div style={{ color:'white' }}><b>Approved Requisitions </b></div>
                                </CardText>
                            </CardBody>
                        </Card>
                        <Card className="mb-3 notapproved_requisition_card">
                            <CardBody>
                                <CardTitle tag="h5">
                                    <div style={{ display: 'flex', alignItems: 'center', color:'white' }}>
                                      {/* <span><CloseIcon /></span> */}
                                      <span><svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 22v-2H5V4h10v4h4v5h2V7l-5-5H3.999A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992zm9.536-.879L19.414 19l2.122-2.121l-1.415-1.415l-2.12 2.122l-2.122-2.122l-1.414 1.415l2.12 2.12l-2.12 2.122l1.414 1.414L18 20.415l2.121 2.12z"/></svg></span>
                                    <span style={{ marginLeft: '8px', color: 'white',fontSize:'22px', fontWeight:'600' }}>{totalNotApprovedRequisition}</span>
                                    </div>
                                </CardTitle>
                                <CardText>
                                <div style={{ color:'white' }}><b>Not Approved Requisition</b></div>  
                                </CardText>
                            </CardBody>
                        </Card>
                </div>
            
                <Dashboard/>
        </Container>
      </div>
     
    </React.Fragment>
  );
};

export default ExecutiveDashboard;
